import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { ThreadObject } from '@/types';

const useGetThreadStatus = ({ caseId, threadId, enabled }: { caseId: string; threadId: string; enabled: boolean }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getThreadStatus = async (): Promise<ThreadObject> => {
    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/thread/${threadId}`, fetchConfigGET);
    if (!response.ok) {
      throw new Error('Fetching messages failed');
    }
    return response.json();
  };

  const { data, refetch, error } = useQuery([QueryEntity.ThreadStatus, threadId], getThreadStatus, {
    cacheTime: 0,
    enabled,
  });

  return {
    data,
    refetch,
    error,
  };
};

export default useGetThreadStatus;
